module.exports = __webpack_public_path__ + "static/globuliCase-011283fe1fe146343e91de024eb90340.jpg";